export default __webpack_public_path__ + "static/MessinaSansWeb-BookItalic-1907e3fdc59025bb64c8440e01364ed5.woff2";